<template>
  <div>
    <div>
      <el-button size="mini" type="primary" @click="setData">保存</el-button>
      <el-button size="mini" @click="setComponentId('FurnishList')">返回</el-button>
    </div>
    <div>
      <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
        <el-descriptions-item label="确认时间">
          <el-date-picker size="mini" type="date" placeholder="确认时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.check_date" style="width: 100%;"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="确认具体内容">
          <div>
            <el-checkbox-group v-model="form.CheckHouseIntegrityBody">
              <p v-for="(item,index) in checked_item2_list" :key="index" style="margin: 5px 0;">
                <el-checkbox :data-id="item.id" :label="item.id">{{item.name}}</el-checkbox>
              </p>
            </el-checkbox-group>
          </div>
          <div>
            <el-input size="mini" type="textarea" :rows="3" v-model="form.CheckHouseIntegrityRemark" placeholder="其他备注"></el-input>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="房屋完好确认单">
          <el-descriptions size="mini" :label-style="{width: '100px'}" direction="vertical" :column="2" border>
            <el-descriptions-item label="模板下载">
              <el-link type="primary" style="min-width: 250px;" @click="dowQueRen">《房屋完好确认单》下载</el-link>
            </el-descriptions-item>
            <el-descriptions-item label="文件上传">
              <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="房屋完好确认单" />
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
import FlowHttp from "../../common/FlowHttp";
import Http from "../../common/Http";
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";

export default {
  name: "FinishedProductsProtection",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      checked_item2_list: [
        {id:1,name:"1、给/排水工程"},
        {id:2,name:"2、强/弱电工程"},
        {id:3,name:"3、防水工程（本户已对所有防水层作严格闭水实验并确认）"},
        {id:4,name:"4、煤气、直饮水工程"},
        {id:5,name:"5、入户门/房门"},
        {id:6,name:"6、窗户/玻璃"},
        {id:7,name:"7、阳台护栏"},
        {id:8,name:"8、楼宇外观"},
        {id:9,name:"9、公共区域和楼道"},
        {id:10,name:"10、公共设施设备"},
        {id:11,name:"11、其他"},
      ],
      loading:false,
      form:{
        CheckHouseIntegrityDate:"",
        CheckHouseIntegrityBody:[],
        CheckHouseIntegrityFile:"",
        CheckHouseIntegrityRemark:""
      }
    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          try {
            if(ret.data.CheckHouseIntegrityBody){
              ret.data.CheckHouseIntegrityBody=JSON.parse(ret.data.CheckHouseIntegrityBody)
            }else {
              ret.data.CheckHouseIntegrityBody=[];
            }

          }catch (e) {
            ret.data.CheckHouseIntegrityBody=[];
          }

          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    dowQueRen(){
      if(!this.mainObj.house_id){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      const that = this;
      ERP.showLoading()
      FlowHttp.post('house/HouseFurnish/getFinishedProductsProtection',{house_id:that.mainObj.house_id,id:that.mainObj.id},ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(FlowHttp.getBaseURL() +ret.data)
        }
      })
    },
    setData(){
      const that = this;
      let form=ERP.reJson(that.form)
      if(!form.HouseID){
        form.HouseID=that.main.house_id;
      }
      try {
        form.CheckHouseIntegrityBody=JSON.stringify(form.CheckHouseIntegrityBody)
      }catch (e) {
        form.CheckHouseIntegrityBody="";
      }
      ERP.postRequest({url:"admin/HouseFurnish/setFurnish",data:form},ret=>{
        if(ret.code){
          that.mainObj.id=ret.data.ID;
          that.$msgbox.alert(ret.msg||"修改成功")
        }else{
          that.$msgbox.alert(ret.msg||"修改失败")
        }
      })
    },
    uploadFile(file_key){
      const that=this;
      Http.uploadFile(ret=>{
        that.form[file_key]=ret.path
        that.setData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FinishedProductsProtection.vue